/* ============================================================================
   CONTROL DE PEDIDOS — Portal Kennedy
   ---------------------------------------------------------------------------
   El equivalente al panel "Pedidos de Clientes" de SAP: el filtro por vendedor
   a la izquierda y, a la derecha, los pedidos sin autorizar arriba y los
   autorizados con su monto pendiente abajo, cada bloque con sus totales.

   Solo administracion y gerencia. Muestra saldos de clientes y el pipeline
   completo de la empresa: no es informacion para el equipo de ventas.

   DE DONDE SALE CADA COSA
     pedidos         cabecera y lineas (una fila por linea: se agrupa aqui)
     vista_pedidos   autorizado y los % de entregado / devuelto / facturado
     clientes        pais, condicion de pago y saldo

   Lo que el panel de SAP tiene y aqui NO, porque el dato no se sincroniza:
     Hora        SAP guarda DocTime; el portal solo trae la fecha
     Ley 23      no es un campo del cliente en lo que se sincroniza
     Traspaso    no esta en `pedidos`
   Si hiciera falta, se añaden al sync y aparecen; preferi dejarlas fuera a
   pintar columnas vacias que parezcan un error.

   Prefijo `cpd`.
============================================================================ */

var CPD_ROWS=[], CPD_VEND={}, CPD_Q='', CPD_CARGANDO=false, CPD_EXTRA={};
var CPD_ORDEN={na:'docnum', au:'pendiente'};

// ── Utilidades ──────────────────────────────────────────────────────────────
function cpdEsc(s){
  return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;')
    .replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}
function cpdNum(v){ var n=Number(v); return isFinite(n)?n:0; }
function cpdMon(v){
  return cpdNum(v).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
}
function cpdFecha(f){
  var p=String(f||'').slice(0,10).split('-');
  return p.length===3 ? (p[2]+'/'+p[1]+'/'+p[0].slice(2)) : '';
}
function cpdRol(){
  try{ return String((typeof CU!=='undefined'&&CU&&CU.rol)||'').toLowerCase(); }
  catch(e){ return ''; }
}
function cpdEsAdmin(){ return ['admin','administrador','gerencia'].indexOf(cpdRol())>=0; }
// Los vendedores entran, pero solo a lo suyo. Los clientes no.
function cpdPuede(){ return cpdEsAdmin() || cpdRol()==='vendedor'; }

// El nombre del vendedor en SAP, que es como viene en los pedidos. Hace falta
// para reconocer los codigos COMPARTIDOS: "LEO/HENRY" o "TAMARA/HENRY" son
// pedidos de Henry tambien, y por slpcode no se ven porque cada combinacion
// tiene el suyo propio.
var CPD_MINOMBRE='';

async function cpdMiNombre(){
  if(CPD_MINOMBRE) return CPD_MINOMBRE;
  var sc=null;
  try{ sc=(CU&&CU.slpcode); }catch(e){}
  if(sc!=null && sc!==''){
    try{
      var r=await q('vendedores','select=slpname&slpcode=eq.'+encodeURIComponent(sc)+'&limit=1');
      if(r && r[0] && r[0].slpname) CPD_MINOMBRE=String(r[0].slpname).trim();
    }catch(e){}
  }
  if(!CPD_MINOMBRE){
    // Sin slpcode se cae al nombre del usuario. Peor, pero mejor que nada.
    try{ CPD_MINOMBRE=String((CU&&(CU.nombre||CU.username))||'').trim(); }catch(e){}
  }
  return CPD_MINOMBRE;
}

// Un pedido es "mio" si el vendedor del documento es mi nombre, o si soy una
// de las partes de un codigo compartido. Se compara por partes separadas por
// "/" para que "03/ALICIA" cuente para Alicia y "LEO/HENRY" para los dos.
function cpdEsMio(vendedor){
  var yo=String(CPD_MINOMBRE||'').toUpperCase().trim();
  if(!yo) return false;
  return String(vendedor||'').toUpperCase().split(/[\/,+]/)
    .some(function(p){ return p.trim()===yo; });
}


/* ══════════════════════════════════════════════════════════════════════════
   CARGA
   ══════════════════════════════════════════════════════════════════════════ */

function cpdInit(){
  if(!cpdPuede()){
    var c=document.getElementById('cpd-content');
    if(c) c.innerHTML='<div class="card" style="text-align:center;padding:30px;color:var(--text3)">'
      +'Esta pantalla no est\u00e1 disponible para tu usuario.</div>';
    return;
  }
  cpdCSS();
  if(cpdEsAdmin()){
    if(!CPD_ROWS.length) cpdCargar(); else cpdPintar();
  } else {
    // El vendedor necesita su nombre antes de filtrar.
    cpdMiNombre().then(function(){
      if(!CPD_ROWS.length) cpdCargar(); else cpdPintar();
    });
  }
}

function cpdCSS(){
  if(document.getElementById('cpd-css')) return;
  var st=document.createElement('style');
  st.id='cpd-css';
  st.textContent=[
  '.cpd-lay{display:grid;grid-template-columns:210px minmax(0,1fr);gap:12px;align-items:start}',
  '@media(max-width:1023px){.cpd-lay{grid-template-columns:1fr}}',
  '.cpd-vend{max-height:70vh;overflow-y:auto}',
  '.cpd-v{display:flex;align-items:center;gap:7px;padding:3px 5px;border-radius:6px;',
     'font-size:12px;cursor:pointer;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
  '.cpd-v:hover{background:rgba(127,127,127,.08)}',
  '.cpd-wrap{border:1px solid var(--border);border-radius:var(--r,12px);background:var(--surface);',
     'overflow:hidden;margin-bottom:14px}',
  '.cpd-hd{padding:9px 12px;font-size:11.5px;font-weight:700;text-transform:uppercase;',
     'letter-spacing:.04em;display:flex;gap:10px;align-items:center;flex-wrap:wrap}',
  '.cpd-sc{overflow:auto;max-height:44vh}',
  '.cpd-t{width:100%;border-collapse:collapse;font-size:11.5px;min-width:1080px}',
  '.cpd-t th{position:sticky;top:0;z-index:2;background:var(--surface2,#F3F4F6);padding:7px 7px;',
     'text-align:left;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.03em;',
     'color:var(--text3);border-bottom:1px solid var(--border);white-space:nowrap;cursor:pointer}',
  '.cpd-t th:hover{color:var(--blue2)}',
  '.cpd-t td{padding:5px 7px;border-bottom:1px solid var(--border);white-space:nowrap}',
  '.cpd-t tbody tr:nth-child(even){background:rgba(127,127,127,.03)}',
  '.cpd-t tbody tr:hover{background:rgba(79,140,255,.09)}',
  '.cpd-t .n{text-align:right}',
  '.cpd-t tfoot td{position:sticky;bottom:0;background:var(--surface2,#F3F4F6);font-weight:700;',
     'border-top:2px solid var(--border);padding:7px}',
  '.cpd-cli{max-width:190px;overflow:hidden;text-overflow:ellipsis;display:inline-block;',
     'vertical-align:bottom}',
  '.cpd-com{max-width:220px;overflow:hidden;text-overflow:ellipsis;display:inline-block;',
     'vertical-align:bottom;color:var(--text3)}',
  '.cpd-cont{background:#FDE8C8;color:#7A3E00;font-size:9.5px;font-weight:700;padding:1px 5px;',
     'border-radius:4px}',
  '.cpd-neg{color:#DC2626;font-weight:700}',
  '.cpd-bar{display:inline-block;width:42px;height:6px;border-radius:3px;background:#E5E7EB;',
     'vertical-align:middle;overflow:hidden}',
  '.cpd-bar i{display:block;height:100%;background:#2563EB}'
  ].join('');
  document.head.appendChild(st);
}

async function cpdCargar(){
  if(CPD_CARGANDO) return;
  CPD_CARGANDO=true;
  var c=document.getElementById('cpd-content');
  var _av=function(t){
    if(c) c.innerHTML='<div class="card" style="text-align:center;padding:30px;'
      +'color:var(--text3)">'+t+'</div>';
  };
  _av('Cargando los pedidos abiertos\u2026');

  try{
    // Solo los pedidos ABIERTOS: es lo que muestra el panel de SAP y lo que
    // deja la consulta en un tamaño razonable. Un pedido cerrado ya no se
    // autoriza ni queda pendiente.
    // qAll y no q: PostgREST corta en 1000 filas por defecto, y como `pedidos`
    // tiene una fila por LINEA, mil lineas son apenas una veintena de pedidos.
    // Pedir limit=20000 no sirve de nada: el servidor lo ignora y devuelve su
    // tope. qAll pagina y se ajusta solo a ese tope.
    var lineas=await qAll('pedidos',
      'select=docnum,docdate,cardcode,cardname,doctotal,slpcode,nombrevendedor,comments,'
      +'marca_cliente,linetotal,openqty,quantity,delivrdqty,docstatus'
      +'&docstatus=eq.O&order=docnum.desc') || [];

    // `pedidos` trae una fila por LINEA: se agrupa por documento y de paso se
    // suma el subtotal, que no viene en la cabecera.
    var docs={};
    lineas.forEach(function(l){
      var d=docs[l.docnum];
      if(!d){
        d=docs[l.docnum]={
          docnum:l.docnum, docdate:l.docdate, cardcode:l.cardcode, cardname:l.cardname,
          doctotal:cpdNum(l.doctotal), slpcode:l.slpcode,
          vendedor:l.nombrevendedor||'', comments:l.comments||'',
          marca:l.marca_cliente||'', subtotal:0, lineas:0, abiertas:0,
          qPed:0, qEnt:0
        };
      }
      d.subtotal+=cpdNum(l.linetotal);
      d.lineas++;
      if(cpdNum(l.openqty)>0) d.abiertas++;
      // Piezas pedidas y ya entregadas, para calcular el avance sin depender
      // de la vista.
      d.qPed+=cpdNum(l.quantity);
      d.qEnt+=cpdNum(l.delivrdqty);
    });
    var arr=Object.keys(docs).map(function(k){ return docs[k]; });
    _av(arr.length+' pedido(s) \u00b7 leyendo su estado\u2026');

    // Estado de autorizacion y avance. select=* a proposito: la vista cambia
    // de columnas segun la instalacion y pedirlas por nombre devuelve 400.
    var est={};
    for(var i=0;i<arr.length;i+=300){
      var lote=arr.slice(i,i+300).map(function(d){ return d.docnum; });
      try{
        var v=await qAll('vista_pedidos','select=*&docnum=in.('+lote.join(',')+')');
        (v||[]).forEach(function(x){ est[x.docnum]=x; });
      }catch(e){}
    }

    // Pais, condicion de pago y saldo del cliente.
    var cli={};
    var codes=Array.from(new Set(arr.map(function(d){ return d.cardcode; }).filter(Boolean)));
    for(var j=0;j<codes.length;j+=300){
      var en=codes.slice(j,j+300)
        .map(function(x){ return '"'+String(x).replace(/"/g,'')+'"'; }).join(',');
      try{
        var cs=await qAll('clientes',
          'select=cardcode,country,condicionpago,balance,ordersbal,dnotesbal'
          +'&cardcode=in.('+en+')');
        (cs||[]).forEach(function(x){ cli[x.cardcode]=x; });
      }catch(e){}
    }

    arr.forEach(function(d){
      var e=est[d.docnum]||{}, k=cli[d.cardcode]||{};
      d.autorizado = (e.autorizado===true);
      d.conEstado  = (e.autorizado!==undefined);
      d.pctFact    = cpdNum(e.pct_facturado);
      // El % entregado sale de las propias lineas (delivrdqty / quantity). La
      // vista tambien lo trae, pero para pedidos abiertos venia vacia y las
      // dos columnas de avance quedaban en blanco. Se usa el de la vista si
      // trae algo, y si no el calculado, que siempre esta.
      d.pctEnt     = cpdNum(e.pct_entregado);
      if(!d.pctEnt && d.qPed>0) d.pctEnt = d.qEnt/d.qPed*100;
      // Lo devuelto si depende de la vista: cruzarlo con `devoluciones` seria
      // otra consulta y aqui no compensa. Sin dato se muestra un guion, no un
      // cero: no es lo mismo "no se devolvio nada" que "no lo se".
      d.pctDev     = (e.pct_devuelto==null) ? null : cpdNum(e.pct_devuelto);
      d.autorizo   = e.autorizado_por || e.autorizo || '';
      // Lo ya facturado y lo que falta, a partir del avance de la vista.
      d.facturado  = d.doctotal * d.pctFact/100;
      d.pendiente  = d.doctotal - d.facturado;
      d.pais       = k.country || '';
      d.condicion  = k.condicionpago || '';
      // El saldo del cliente: lo que debe. Se muestra para decidir si conviene
      // autorizar mas mercancia.
      d.saldo      = cpdNum(k.balance);
    });

    // El vendedor solo ve lo suyo. Se filtra AQUI y no al pintar, para que no
    // quede en memoria el pipeline de los demas.
    if(!cpdEsAdmin()){
      arr=arr.filter(function(d){ return cpdEsMio(d.vendedor); });
    }
    CPD_ROWS=arr;
    // Si alguna instalacion trae quien autorizo, se muestra la columna.
    CPD_EXTRA.autorizo = arr.some(function(d){ return !!d.autorizo; });

    // Lista de vendedores, de los propios pedidos. Todos marcados al entrar.
    var v={};
    arr.forEach(function(d){ v[d.vendedor||'(sin vendedor)']=1; });
    CPD_VEND={};
    Object.keys(v).sort().forEach(function(n){ CPD_VEND[n]=true; });

    cpdPintar();
  }catch(e){
    if(c) c.innerHTML='<div class="card" style="color:var(--red);padding:20px">'
      +'No se pudieron cargar los pedidos: '+cpdEsc(e.message||e)+'</div>';
  }finally{
    CPD_CARGANDO=false;
  }
}


/* ══════════════════════════════════════════════════════════════════════════
   FILTRAR Y ORDENAR
   ══════════════════════════════════════════════════════════════════════════ */

function cpdVisibles(){
  var t=CPD_Q.toLowerCase();
  return CPD_ROWS.filter(function(d){
    if(cpdEsAdmin() && !CPD_VEND[d.vendedor||'(sin vendedor)']) return false;
    if(t){
      var s=(d.docnum+' '+d.cardcode+' '+d.cardname+' '+d.pais+' '+d.marca+' '
        +d.vendedor+' '+d.comments).toLowerCase();
      if(s.indexOf(t)<0) return false;
    }
    return true;
  });
}

function cpdOrdenar(arr, campo){
  var txt={cardname:1, pais:1, vendedor:1, condicion:1, marca:1, comments:1, cardcode:1};
  return arr.slice().sort(function(a,b){
    if(txt[campo]) return String(a[campo]||'').localeCompare(String(b[campo]||''),'es');
    if(campo==='docdate') return String(b.docdate||'').localeCompare(String(a.docdate||''));
    return cpdNum(b[campo])-cpdNum(a[campo]);
  });
}

function cpdSetOrden(panel, campo){
  CPD_ORDEN[panel]=campo;
  cpdPintarTablas();
}
function cpdBuscar(v){
  CPD_Q=v;
  clearTimeout(window._cpdT);
  window._cpdT=setTimeout(cpdPintarTablas, 200);
}
function cpdVend(nombre, on){
  CPD_VEND[nombre]=!!on;
  cpdPintarTablas();
}
function cpdVendTodos(on){
  Object.keys(CPD_VEND).forEach(function(k){ CPD_VEND[k]=!!on; });
  cpdPintar();
}


/* ══════════════════════════════════════════════════════════════════════════
   PINTAR
   ══════════════════════════════════════════════════════════════════════════ */

function cpdPintar(){
  var c=document.getElementById('cpd-content'); if(!c) return;
  cpdCSS();

  var h='';
  h+='<div style="display:flex;gap:9px;align-items:center;flex-wrap:wrap;margin-bottom:12px">';
  h+='<input id="cpd-q" class="inp" value="'+cpdEsc(CPD_Q)+'" oninput="cpdBuscar(this.value)" '
    +'placeholder="Pedido, cliente, pa\u00eds, marca o comentario" style="flex:1;min-width:220px">';
  h+='<button class="btn btn-sm" onclick="cpdCargar()">\u21bb Actualizar</button>';
  h+='<button class="btn btn-sm" id="cpd-xls" onclick="cpdExcel()">\ud83d\udcca Excel</button>';
  h+='</div>';

  var admin=cpdEsAdmin();
  h+='<div class="cpd-lay"'+(admin?'':' style="grid-template-columns:1fr"')+'>';

  // ── Vendedores: solo tiene sentido para quien ve los de todos ──
  if(admin){
  h+='<div class="card" style="padding:10px">';
  h+='<div style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;'
    +'color:var(--text3);margin-bottom:7px">Escoja el vendedor</div>';
  h+='<div style="display:flex;gap:6px;margin-bottom:6px">'
    +'<button class="btn btn-sm" style="flex:1;font-size:11px" onclick="cpdVendTodos(true)">Todos</button>'
    +'<button class="btn btn-sm" style="flex:1;font-size:11px" onclick="cpdVendTodos(false)">Ninguno</button>'
    +'</div>';
  h+='<div class="cpd-vend">';
  Object.keys(CPD_VEND).forEach(function(n){
    var j=n.replace(/'/g,"\\'");
    h+='<label class="cpd-v" title="'+cpdEsc(n)+'">'
      +'<input type="checkbox"'+(CPD_VEND[n]?' checked':'')
      +' onchange="cpdVend(\''+j+'\',this.checked)">'+cpdEsc(n)+'</label>';
  });
  h+='</div></div>';
  }

  // ── Las dos tablas ──
  h+='<div id="cpd-tablas"></div>';
  h+='</div>';

  c.innerHTML=h;
  cpdPintarTablas();
}

function cpdPintarTablas(){
  var box=document.getElementById('cpd-tablas'); if(!box) return;
  var vis=cpdVisibles();
  var na=vis.filter(function(d){ return !d.autorizado; });
  var au=vis.filter(function(d){ return d.autorizado; });
  box.innerHTML = cpdTablaNA(cpdOrdenar(na, CPD_ORDEN.na))
                + cpdTablaAU(cpdOrdenar(au, CPD_ORDEN.au));
}

function cpdCabecera(panel, cols){
  return cols.map(function(c){
    var act=(CPD_ORDEN[panel]===c.k);
    return '<th'+(c.n?' class="n"':'')+' onclick="cpdSetOrden(\''+panel+'\',\''+c.k+'\')"'
      +(act?' style="color:var(--blue2)"':'')+'>'+cpdEsc(c.t)+(act?' \u25bc':'')+'</th>';
  }).join('');
}

function cpdCeldasComunes(d){
  return '<td><b>'+cpdEsc(d.docnum)+'</b></td>'
    +'<td>'+cpdFecha(d.docdate)+'</td>'
    +'<td>'+(/CONTADO/i.test(d.condicion)
        ? '<span class="cpd-cont">'+cpdEsc(d.condicion)+'</span>'
        : cpdEsc(d.condicion))+'</td>'
    +'<td>'+cpdEsc(d.cardcode)+'</td>'
    +'<td><span class="cpd-cli" title="'+cpdEsc(d.cardname)+'">'+cpdEsc(d.cardname)+'</span></td>'
    +'<td>'+cpdEsc(d.pais)+'</td>'
    +'<td>'+cpdEsc(d.marca)+'</td>';
}

function cpdTablaNA(arr){
  var cols=[{k:'docnum',t:'Pedido'},{k:'docdate',t:'Fecha'},{k:'condicion',t:'Condici\u00f3n'},
    {k:'cardcode',t:'C\u00f3digo'},{k:'cardname',t:'Cliente'},{k:'pais',t:'Pa\u00eds'},
    {k:'marca',t:'Marca'},{k:'subtotal',t:'SubTotal',n:1},{k:'doctotal',t:'Total',n:1},
    {k:'saldo',t:'Saldo cliente',n:1},{k:'vendedor',t:'Vendedor'},{k:'comments',t:'Comentarios'}];

  var tSub=0, tTot=0;
  arr.forEach(function(d){ tSub+=d.subtotal; tTot+=d.doctotal; });

  var h='<div class="cpd-wrap">';
  h+='<div class="cpd-hd" style="background:#FDECEC;color:#7F1D1D">'
    +'<span>Pedidos no autorizados</span>'
    +'<span style="font-weight:400;text-transform:none;letter-spacing:0;font-size:12px">'
    +arr.length+' pedido(s) \u00b7 '+cpdMon(tTot)+'</span></div>';
  h+='<div class="cpd-sc"><table class="cpd-t"><thead><tr>'+cpdCabecera('na',cols)+'</tr></thead><tbody>';

  if(!arr.length){
    h+='<tr><td colspan="'+cols.length+'" style="text-align:center;padding:20px;'
      +'color:var(--text3)">Nada pendiente de autorizar con este filtro.</td></tr>';
  }
  arr.forEach(function(d){
    h+='<tr style="cursor:pointer" onclick="cpdVer('+d.docnum+')">'
      +cpdCeldasComunes(d)
      +'<td class="n">'+cpdMon(d.subtotal)+'</td>'
      +'<td class="n"><b>'+cpdMon(d.doctotal)+'</b></td>'
      +'<td class="n'+(d.saldo<0?' cpd-neg':'')+'">'+cpdMon(d.saldo)+'</td>'
      +'<td>'+cpdEsc(d.vendedor)+'</td>'
      +'<td><span class="cpd-com" title="'+cpdEsc(d.comments)+'">'+cpdEsc(d.comments)+'</span></td>'
      +'</tr>';
  });
  h+='</tbody><tfoot><tr>'
    +'<td colspan="7" style="text-align:right">Total</td>'
    +'<td class="n">'+cpdMon(tSub)+'</td>'
    +'<td class="n">'+cpdMon(tTot)+'</td>'
    +'<td colspan="3"></td></tr></tfoot></table></div></div>';
  return h;
}

function cpdTablaAU(arr){
  var cols=[{k:'docnum',t:'Pedido'},{k:'docdate',t:'Fecha'},{k:'condicion',t:'Condici\u00f3n'},
    {k:'cardcode',t:'C\u00f3digo'},{k:'cardname',t:'Cliente'},{k:'pais',t:'Pa\u00eds'},
    {k:'marca',t:'Marca'},{k:'doctotal',t:'Total',n:1},{k:'facturado',t:'Facturado',n:1},
    {k:'pctFact',t:'% Fact.',n:1},{k:'pendiente',t:'Pendiente',n:1},
    {k:'pctEnt',t:'% Entreg.',n:1},{k:'pctDev',t:'% Devuel.',n:1},
    {k:'vendedor',t:'Vendedor'}];
  if(CPD_EXTRA.autorizo) cols.push({k:'autorizo',t:'Autoriz\u00f3'});
  cols.push({k:'comments',t:'Comentarios'});

  var tTot=0, tFac=0, tPen=0;
  arr.forEach(function(d){ tTot+=d.doctotal; tFac+=d.facturado; tPen+=d.pendiente; });

  var h='<div class="cpd-wrap">';
  h+='<div class="cpd-hd" style="background:#E6F1EC;color:#0B5138">'
    +'<span>Pedidos autorizados y montos pendientes</span>'
    +'<span style="font-weight:400;text-transform:none;letter-spacing:0;font-size:12px">'
    +arr.length+' pedido(s) \u00b7 pendiente '+cpdMon(tPen)+'</span></div>';
  h+='<div class="cpd-sc"><table class="cpd-t"><thead><tr>'+cpdCabecera('au',cols)+'</tr></thead><tbody>';

  if(!arr.length){
    h+='<tr><td colspan="'+cols.length+'" style="text-align:center;padding:20px;'
      +'color:var(--text3)">Sin pedidos autorizados con este filtro.</td></tr>';
  }
  arr.forEach(function(d){
    h+='<tr style="cursor:pointer" onclick="cpdVer('+d.docnum+')">'
      +cpdCeldasComunes(d)
      +'<td class="n"><b>'+cpdMon(d.doctotal)+'</b></td>'
      +'<td class="n">'+cpdMon(d.facturado)+'</td>'
      +'<td class="n">'+cpdBarra(d.pctFact)+'</td>'
      +'<td class="n"><b>'+cpdMon(d.pendiente)+'</b></td>'
      +'<td class="n">'+cpdBarra(d.pctEnt)+'</td>'
      +'<td class="n">'+(d.pctDev==null ? '<span style="color:var(--text3)">\u2014</span>'
          : (d.pctDev>0 ? ('<span class="cpd-neg">'+d.pctDev.toFixed(0)+'%</span>')
                        : '0%'))+'</td>'
      +'<td>'+cpdEsc(d.vendedor)+'</td>'
      +(CPD_EXTRA.autorizo?('<td>'+cpdEsc(String(d.autorizo||'').split('@')[0])+'</td>'):'')
      +'<td><span class="cpd-com" title="'+cpdEsc(d.comments)+'">'+cpdEsc(d.comments)+'</span></td>'
      +'</tr>';
  });
  h+='</tbody><tfoot><tr>'
    +'<td colspan="7" style="text-align:right">Total</td>'
    +'<td class="n">'+cpdMon(tTot)+'</td>'
    +'<td class="n">'+cpdMon(tFac)+'</td><td></td>'
    +'<td class="n">'+cpdMon(tPen)+'</td>'
    +'<td colspan="'+(CPD_EXTRA.autorizo?4:3)+'"></td></tr></tfoot></table></div></div>';
  return h;
}

// El porcentaje con una barrita: de un vistazo se ve cuales van a medias.
function cpdBarra(pct){
  var p=Math.max(0, Math.min(100, cpdNum(pct)));
  return '<span class="cpd-bar"><i style="width:'+p.toFixed(0)+'%"></i></span> '
    +p.toFixed(0)+'%';
}

function cpdVer(docnum){
  try{ VISTA_ACTUAL=function(){ go('control_pedidos', document.getElementById('nav-cpd')); }; }catch(e){}
  try{ verPedido(docnum); }catch(e){}
}


/* ══════════════════════════════════════════════════════════════════════════
   EXCEL
   ══════════════════════════════════════════════════════════════════════════ */

async function cpdExcel(){
  if(typeof xlsxExport!=='function'){ alert('El generador de Excel no est\u00e1 disponible.'); return; }
  var b=document.getElementById('cpd-xls');
  var prev=b?b.innerHTML:null;
  if(b){ b.disabled=true; b.textContent='Generando\u2026'; }
  try{
    var vis=cpdVisibles();
    if(!vis.length){ alert('No hay pedidos con este filtro.'); return; }
    // Una sola hoja con una columna que separa los dos bloques: en Excel se
    // filtra y se ordena, que es mejor que dos pestañas.
    var filas=cpdOrdenar(vis,'docnum').map(function(d){
      return Object.assign({}, d, {__estado: d.autorizado?'AUTORIZADO':'NO AUTORIZADO'});
    });
    await xlsxExport({
      filename:'control-pedidos.xlsx',
      titulo:'KENNEDY CENTER CORP. - CONTROL DE PEDIDOS',
      subtitulo:filas.length+' pedido(s) abiertos  -  '
        +filas.filter(function(d){return !d.autorizado;}).length+' sin autorizar',
      columns:[
        {label:'Estado',        key:'__estado',  width:16},
        {label:'Pedido',        key:'docnum',    width:12, numFmt:'0'},
        {label:'Fecha',         key:'__f',       width:12},
        {label:'Condici\u00f3n',key:'condicion', width:20},
        {label:'C\u00f3digo',   key:'cardcode',  width:12},
        {label:'Cliente',       key:'cardname',  width:34},
        {label:'Pa\u00eds',     key:'pais',      width:10},
        {label:'Marca',         key:'marca',     width:16},
        {label:'SubTotal',      key:'subtotal',  width:14, numFmt:'#,##0.00'},
        {label:'Total',         key:'doctotal',  width:14, numFmt:'#,##0.00'},
        {label:'Facturado',     key:'facturado', width:14, numFmt:'#,##0.00'},
        {label:'% Fact.',       key:'pctFact',   width:9,  numFmt:'0'},
        {label:'Pendiente',     key:'pendiente', width:14, numFmt:'#,##0.00'},
        {label:'% Entreg.',     key:'pctEnt',    width:10, numFmt:'0'},
        {label:'% Devuel.',     key:'pctDev',    width:10, numFmt:'0'},
        {label:'Saldo cliente', key:'saldo',     width:14, numFmt:'#,##0.00'},
        {label:'Vendedor',      key:'vendedor',  width:18},
        {label:'Comentarios',   key:'comments',  width:40}
      ],
      rows:filas,
      valueFn:function(d,k){
        if(k==='__f') return cpdFecha(d.docdate);
        if(['subtotal','doctotal','facturado','pendiente','saldo','pctFact','pctEnt','pctDev']
             .indexOf(k)>=0) return cpdNum(d[k]);
        if(k==='docnum') return cpdNum(d.docnum);
        return d[k]==null?'':d[k];
      }
    });
  }catch(e){
    alert('No se pudo generar el Excel: '+(e&&e.message?e.message:e));
  }finally{
    if(b){ b.disabled=false; b.innerHTML=prev; }
  }
}
